import { CaretRight } from "@phosphor-icons/react";
import { STAGE, fmtInt } from "@/lib/format";

export const FunnelFlow = ({ funnel }) => {
  const data = funnel || [];
  const max = Math.max(1, ...data.map((d) => d.count));

  return (
    <div className="col-span-12 border border-[#E3E7EC] bg-[#FFFFFF] p-5 lg:col-span-4">
      <div className="mb-4">
        <h3 className="text-sm font-semibold text-[#0F172A]">Procurement Pipeline</h3>
        <p className="pf-label mt-0.5">OR → OQ → OF · current stage</p>
      </div>
      <div className="flex flex-col gap-2" data-testid="funnel-flow">
        {data.map((d, i) => {
          const meta = STAGE[d.stage] || { color: "#64748B", name: d.stage };
          const pct = (d.count / max) * 100;
          return (
            <div key={d.stage}>
              <div className="relative overflow-hidden rounded-sm border border-[#E3E7EC] bg-[#F1F3F6] p-3" data-testid={`funnel-stage-${d.stage}`}>
                <div className="absolute inset-y-0 left-0 opacity-15" style={{ width: `${pct}%`, background: meta.color }} />
                <div className="relative flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <span className="flex h-8 w-9 items-center justify-center rounded-sm font-mono text-sm font-semibold text-[#FFFFFF]" style={{ background: meta.color }}>
                      {d.stage}
                    </span>
                    <div>
                      <div className="pf-label">avg {fmtInt(d.avg_age)}d open</div>
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="font-mono text-xl font-semibold text-[#0F172A]">{fmtInt(d.count)}</div>
                    <div className="font-mono text-[11px] text-[#64748B]">lines</div>
                  </div>
                </div>
              </div>
              {i < data.length - 1 && (
                <div className="flex justify-center py-0.5 text-[#CAD1DB]">
                  <CaretRight size={16} weight="bold" className="rotate-90" />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
